import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { withConfig } from 'src/withConfig';

const setEventMainSection = (unified: boolean, theme: EmotionTheme): SerializedStyles => {
  if (unified) {
    return css`
        background-color: ${theme.star.unified.layoutGlobal.bgColor};
        display: flex;
        flex-flow: column;
        flex: 1;
    `
  }

  return css`
      background-color: ${theme.star.eventsGroupedFiltersColors.bgColorSecondary};
  `
}

export const EventMainSection = withConfig(theme => styled('div', { label: 'EventMainSection' })<{unified?: boolean}>`
    ${({ unified = false }) => setEventMainSection(unified, theme)}
`);
